export default __webpack_public_path__ + "static/media/intro.6f2b561d.wav";